import CtverecProKresleni from './CtverecProKresleni';

export default class Ctverec {
	private x: number = 0;
	private y: number = 0;
	private strana: number = 40;
	private barva: string = '';
	private zlomekPosunu: number = 2;

	constructor() {}

	posun(): void {
		const smerX = Math.random() < 0.5 ? 1 : -1;
		const smerY = Math.random() < 0.5 ? 1 : -1;
		const posunX = this.strana / this.zlomekPosunu * smerX;
		const posunY = this.strana / this.zlomekPosunu * smerY;
		this.x += posunX;
		this.y += posunY;
		//nebudeme se posouvat na neviditelné místo za okrajem
		const konecX = Math.floor(window.innerWidth / this.strana / this.zlomekPosunu) * this.strana / this.zlomekPosunu;
		const konecY = Math.floor(window.innerHeight / this.strana / this.zlomekPosunu) * this.strana / this.zlomekPosunu;
		if (this.y < 0) this.y = 0;
		else if (this.y > window.innerHeight) this.y = konecY;
		if (this.x < 0) this.x = 0;
		else if (this.x > window.innerWidth) this.x = konecX;
	}

	zmenBarvu(barva: string): void {
		this.barva = barva;
	}

	zmenStranu(strana: number): void {
		this.strana = strana;
	}

	zmenZlomekPosunu(zlomek: number): void {
		this.zlomekPosunu = zlomek;
	}

	vytvorCtverecProKresleni(): CtverecProKresleni {
		return new CtverecProKresleni(this.x, this.y, this.strana, this.barva);
	}
}
